var Mediator = {
  instance: function () {
    if (!Mediator.instance) {
      Mediator.instance = this;
    }
    return Mediator.instance;
  },

  indicators: [],
  mainScreen: {},
  screenGraph1: {},
  screenGraph2: {},
  screenName: "",
  parameterSearch: "",
  adherenceHeadersResults: {},
  listIndicators: {},
  data: {},
  footer: {},

  async notify(sender, event) {
    switch (event) {
      case "init":
        this.mainScreen = sender;
        let dataToGraph = JSON.parse(localStorage.getItem('dataToGraph'));

        if (dataToGraph) {
          this.mainScreen.waitingLoadChart = true;
          setTimeout(() => {
            this.screenGraph1.loadChart(dataToGraph);
            this.screenGraph2.loadChart(generateFieldsForGraph2(dataToGraph));
            this.screenGraph2.screenIndicators = this.parameterSearch.area;
            this.footer.loadInfos(dataToGraph);
          }, 50);
          this.mainScreen.waiting = false;
        }
        break;
      case "loading-infos":
        this.data = sender;
        break;
      case "init-graph-1":
        this.screenGraph1 = sender;
        break;
      case "init-graph-2":
        this.screenGraph2 = sender;
        break;
      case "init-footer-pgdi":
        this.footer = sender;
        break;
      case "update-graph-2-name":
        this.screenName = sender;
        this.screenGraph1.showMessage(this.screenName);
        filtredIndicatorsByHeader(this.data, this.screenName);
        this.screenGraph2.loadChart(
          filtredIndicatorsByHeader(this.data, this.screenName)
        );

        let titleGraph = this.screenName;

        if (this.screenName.includes("(%")) {
          let index = titleGraph.indexOf("(");
          titleGraph = titleGraph.substring(0, index).trim();
          this.screenGraph2.header = titleGraph;
        } else {
          this.screenGraph2.header = this.screenName;
        }
        this.screenGraph2.conditionalDisplayGhaph = true;
        break;

      case "changeScreen":
        this.parameterSearch = sender;
        localStorage.setItem('parameterSearch', JSON.stringify(sender));
        this.mainScreen.waiting = true;
        await this.mainScreen.getAllAdherenceIndicators(this.parameterSearch);
        this.mainScreen.waiting = false;
        setTimeout(() => {
          if (this.mainScreen.res == 200) {
            localStorage.setItem('dataToGraph', JSON.stringify(this.data));
            this.screenGraph1.loadChart(this.data);
            this.screenGraph2.loadChart(generateFieldsForGraph2(this.data));
            this.screenGraph2.screenIndicators = this.parameterSearch.area;
            this.screenGraph2.header = this.parameterSearch.area;
            this.footer.loadInfos(this.data);
          }
        }, 50);
        break;
      case "show-all":
        this.screenGraph2.loadChart(generateFieldsForGraph2(this.data));
        this.screenGraph1.showMessage(this.screenGraph2.screenIndicators);
        break;
    }
  },
};

function filtredIndicatorsByHeader(listIndicators, nameHeader) {
  let indicatorsByHeaderKeys = Object.keys(listIndicators.indicatorsByHeader);
  let index = indicatorsByHeaderKeys.indexOf(nameHeader);
  let indicatorsByHeader = indicatorsByHeaderKeys[index];
  let indicatorsByHeader2 =
    listIndicators.indicatorsByHeader[indicatorsByHeader];

  var list = [];
  Mediator.indicators.forEach((item) => {
    if (indicatorsByHeader2.includes(item.key)) list.push(item);
  });

  return list;
}

function generateFieldsForGraph2(data) {
  let indicators = data.indicatorsList;
  let adherenceMinimumPgdi = data.adherenceMinimumPgdi;
  let indicatorsKey = Object.keys(indicators);
  let indicatorsValue = Object.values(indicators);
  let occurrenceTratedindicators = data.percentOcurrenceTreatedResults;
  let adherecenIndicatorsResults = data.adherecenIndicatorsResults;
  let listIndicators = [];

  for (let index = 0; index < indicatorsKey.length; index++) {
    if (adherecenIndicatorsResults[indicatorsKey[index]]) {
      let element = {
        key: indicatorsKey[index],
        x: indicatorsValue[index],
        y: adherecenIndicatorsResults[indicatorsKey[index]],
        goals: [
          {
            name: "Aderência Mínima (%)",
            value: adherenceMinimumPgdi[indicatorsKey[index]]
              ? adherenceMinimumPgdi[indicatorsKey[index]]
              : adherenceMinimumPgdi[indicatorsKey[0]],
            strokeWidth: 3,
            strokeHeight: 15,
            strokeDashArray: 5,
            strokeColor: "#000",
          },
          {
            name: occurrenceTratedindicators[indicatorsKey[index]] ? "Ocor.Tratadas (%)" : "Ocorrências",
            value: occurrenceTratedindicators[indicatorsKey[index]]
              ? Math.trunc(
                parseFloat(occurrenceTratedindicators[indicatorsKey[index]])
              ).toString()
              : 0,
            strokeWidth: 10,
            strokeHeight: 0,
            strokeLineCap: occurrenceTratedindicators[indicatorsKey[index]] ? "round" : false,
            strokeColor: "#FF7100",
          },
        ],
      };
      listIndicators.push(element);
    }
  }

  let indicatorsFiltred = listIndicators.sort((a, b) =>
    parseFloat(a.y) > parseFloat(b.y)
      ? 1
      : parseFloat(a.y) < parseFloat(b.y)
        ? -1
        : 0
  );
  Mediator.indicators = indicatorsFiltred;
  return indicatorsFiltred;
}

export default Mediator;
